import React from 'react';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import SponsoredCohortAssignmentAnalytics from '../components/SponsoredCohortAssignmentAnalytics';
import SponsoredCohortAssignmentRawData from '../components/SponsoredCohortAssignmentRawData';

const TABS = [
  {
    title: 'Assignment analytics',
    component: <SponsoredCohortAssignmentAnalytics />,
  },
  {
    title: 'Assignment raw data',
    component: <SponsoredCohortAssignmentRawData />,
  },
];

function CohortAssignmentAnalytics() {
  return (
    <AnalyticsPageLayout
      title="Cohort Weekly Assignment Analytics"
      description="Weekly assignment submissions and performance by cohort."
      tabs={TABS}
    />
  );
}

export default CohortAssignmentAnalytics;
